const constants = require('@/util/constants')
require('./config')

/**
 * 注册页面：验证邮箱唯一性
 * @param {*} email 邮箱
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function emailValidate (email, successcb, failedcb) {
  axios.get('/visitor/api/email/validate', {
    params: {
      'email': email
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 找回密码：验证邮箱是否存在
 * @param {*} email 邮箱
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function emailForget (email, successcb, failedcb) {
  axios.get('/visitor/api/email/forget', {
    params: {
      'email': email
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取验证码
 * @param {*} email 邮箱
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getEmailCode (email, successcb, failedcb) {
  axios.get('/visitor/api/email/code', {
    params: {
      'email': email
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 到服务器端验证验证码是否正确
 * @param {*} email 邮箱
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function emailValidateCode (email, code, successcb, failedcb) {
  axios.get('/visitor/api/email/code/validate', {
    params: {
      'email': email,
      'code': code
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 验证二级域名唯一性
 * @param {*} subDomain 二级域名
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function subDomainValidate (subDomain, successcb, failedcb) {
// console.log('subdomain: ', subDomain)
  axios.get('/visitor/api/sub_domain/validate', {
    params: {
      'sub_domain': subDomain
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 远程验证私有部署是否有效
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function serverValidate (uId, successcb, failedcb) {
  axios.get(constants.PRIVATE_SERVER_VALIDATE_URL, {
    params: {
      'uId': uId
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 注册管理员
 * @param {*} username 用户名
 * @param {*} password 密码
 */
export function register (email, password, successcb, failedcb) {
  axios.post('/visitor/api/register', {
    email: email,
    password: password
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 登录页面->忘记密码：修改密码
 */
export function changePassword (email, password, successcb, failedcb) {
  axios.post('/visitor/api/change', {
    email: email,
    password: password
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

// 获取场景二维码：公众号带参二维码url
export function queryMpQrcodeUrl(username, successcb, failedcb) {
  axios.get('/visitor/api/qr/scene/str', {
    params: {
      'wxappid': 'wx89711c5fd9910289',
      'scene': username,
      'client': 'web'
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

// 查询用户是否已经绑定公众号
export function queryOpenId(username, successcb, failedcb) {
  axios.get('/visitor/api/openid', {
    params: {
      'username': username,
      'client': 'web'
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

// 管理员拥有的客服账号, 主要用于访客端
export function queryAllAgents(uid, successcb, failedcb) {
  axios.get('/visitor/api/agent/all', {
    params: {
      'uid': uid,
      'client': 'web'
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}``

// 管理员账号拥有的所有工作组, 主要用于访客端
export function queryAllWorkGroups(uid, successcb, failedcb) {
  axios.get('/visitor/api/workGroup/all', {
    params: {
      'uid': uid,
      'client': 'web'
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}
